// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.top-toolbar {
  position: relative;
  height: 56px;
  z-index: 1;
}

.pin {
  width: 24px;
  height: 24px;
  cursor: pointer;
  fill: currentColor;
}

.sidenav {
  width: 260px;
  overflow: hidden;
  border: none !important;
}

.header {
  position: relative;
  z-index: 2;
  transition: 0.3s;
}
.header.over {
  z-index: 99;
}

.search-bar form input {
  height: 28px;
  border: none;
  padding: 0;
  border-radius: 15px;
  outline: none;
  color: #444;
  width: 0;
  overflow: hidden;
  transition: 0.3s;
}
.search-bar form input.show {
  padding: 0 8px;
  width: 250px;
}

.footer {
  height: 0px;
  position: relative;
  z-index: 3;
}

.options {
  position: fixed;
  width: 260px;
  z-index: 999999;
}
.options .op-header {
  height: 56px;
  padding: 0 14px;
}
.options .control {
  padding: 6px 14px;
}
.options .control div {
  padding: 6px 0;
}
.options .control h4 {
  border-bottom: 1px solid #ccc;
  margin: 12px 0 6px 0;
}
.options .control .skin-primary {
  width: 46px;
  height: 46px;
  padding: 0;
  overflow: hidden;
  cursor: pointer;
}
.options .control .skin-primary .skin-secondary {
  width: 0;
  height: 0;
  padding: 0;
  border-bottom: 46px solid;
  border-left: 46px solid transparent;
}
.options .control .skin-primary.indigo-light {
  background-color: var(--color-primary-light);
  border: 1px solid var(--color-primary-light);
}
.options .control .skin-primary.indigo-light .skin-secondary {
  border-bottom-color: #ececec;
}
.options .control .skin-primary.teal-light {
  background-color: #009688;
  border: 1px solid #009688;
}
.options .control .skin-primary.teal-light .skin-secondary {
  border-bottom-color: #ececec;
}
.options .control .skin-primary.red-light {
  background-color: #F44336;
  border: 1px solid #F44336;
}
.options .control .skin-primary.red-light .skin-secondary {
  border-bottom-color: #ececec;
}
.options .control .skin-primary.gray-light {
  background-color: #757575;
  border: 1px solid #757575;
}
.options .control .skin-primary.gray-light .skin-secondary {
  border-bottom-color: #ececec;
}
.options .control .skin-primary.blue-dark {
  background-color: #0277bd;
  border: 1px solid #0277bd;
}
.options .control .skin-primary.blue-dark .skin-secondary {
  border-bottom-color: #262626;
}
.options .control .skin-primary.green-dark {
  background-color: #388E3C;
  border: 1px solid #388E3C;
}
.options .control .skin-primary.green-dark .skin-secondary {
  border-bottom-color: #262626;
}
.options .control .skin-primary.pink-dark {
  background-color: #D81B60;
  border: 1px solid #D81B60;
}
.options .control .skin-primary.pink-dark .skin-secondary {
  border-bottom-color: #262626;
}
.options .control .skin-primary.gray-dark {
  background-color: #607D8B;
  border: 1px solid #607D8B;
}
.options .control .skin-primary.gray-dark .skin-secondary {
  border-bottom-color: #262626;
}
.options .mat-radio-group,
.options .mat-mdc-radio-group {
  display: inline-flex;
  flex-direction: column;
}
.options .mat-radio-group .mat-radio-button,
.options .mat-radio-group .mat-mdc-radio-button,
.options .mat-mdc-radio-group .mat-radio-button,
.options .mat-mdc-radio-group .mat-mdc-radio-button {
  margin: 2px 0;
}
.options .mat-slide-toggle,
.options .mat-mdc-slide-toggle {
  height: auto;
}
.options .ps {
  height: calc(100% - 56px);
}

.op-image {
  box-shadow: 0 0 2px #ccc;
  border: 2px solid;
  border-color: transparent;
  cursor: pointer;
  transition: 0.2s;
}

.options-icon {
  position: fixed;
  top: 120px;
  right: 0;
  width: 40px;
  height: 40px;
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  cursor: pointer;
  z-index: 99999;
}
.options-icon .mat-icon {
  animation: spin 8s linear infinite;
}
@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}
.back-to-top {
  position: fixed;
  width: 40px;
  height: 40px;
  cursor: pointer;
  z-index: 999999;
  right: 20px;
  bottom: 65px;
  opacity: 0.5;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.75);
  border-radius: 50%;
  transition: 0.3s;
}
.back-to-top:hover {
  opacity: 0.9;
}`, "",{"version":3,"sources":["webpack://./src/app/shared-component/public-layout/public-layout.component.scss","webpack://./src/app/theme/styles/_variables.scss"],"names":[],"mappings":"AAMA;EACI,kBAAA;EACA,YCHiB;EDIjB,UAAA;AALJ;;AAQA;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;AALJ;;AAQA;EACI,YCVY;EDWZ,gBAAA;EACA,uBAAA;AALJ;;AAQA;EACI,kBAAA;EACA,UAAA;EACA,gBAAA;AALJ;AAMI;EACI,WAAA;AAJR;;AAUQ;EACI,YAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;EACA,QAAA;EACA,gBAAA;EACA,gBAAA;AAPZ;AAQY;EACG,cAAA;EACA,YAAA;AANf;;AAYA;EACI,WChDoB;EDiDpB,kBAAA;EACA,UAAA;AATJ;;AAaA;EACI,eAAA;EACA,YCrDY;EDsDZ,eAAA;AAVJ;AAWI;EACI,YC7Da;ED8Db,eAAA;AATR;AAWI;EACI,iBAAA;AATR;AAUQ;EACI,cAAA;AARZ;AAUQ;EACI,6BAAA;EACA,oBAAA;AARZ;AAUQ;EACI,WAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;AARZ;AASY;EACI,QAAA;EACA,SAAA;EACA,UAAA;EACA,yBAAA;EACA,mCAAA;AAPhB;AASY;EACI,4CAAA;EACA,4CAAA;AAPhB;AAQgB;EACI,4BAAA;AANpB;AASY;EACI,yBAAA;EACA,yBAAA;AAPhB;AAQgB;EACI,4BAAA;AANpB;AASY;EACI,yBAAA;EACA,yBAAA;AAPhB;AAQgB;EACI,4BAAA;AANpB;AASY;EACI,yBAAA;EACA,yBAAA;AAPhB;AAQgB;EACI,4BAAA;AANpB;AASY;EACI,yBAAA;EACA,yBAAA;AAPhB;AAQgB;EACI,4BAAA;AANpB;AASY;EACI,yBAAA;EACA,yBAAA;AAPhB;AAQgB;EACI,4BAAA;AANpB;AASY;EACI,yBAAA;EACA,yBAAA;AAPhB;AAQgB;EACI,4BAAA;AANpB;AASY;EACI,yBAAA;EACA,yBAAA;AAPhB;AAQgB;EACI,4BAAA;AANpB;AAWI;;EAEI,oBAAA;EACA,sBAAA;AATR;AAUQ;;;;EAEI,aAAA;AANZ;AASI;;EAEI,YAAA;AAPR;AASI;EACI,yBAAA;AAPR;;AAUA;EACI,wBAAA;EACA,iBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;AAPJ;;AASA;EACI,eAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;AANJ;AAOI;EAGI,kCAAA;AALR;AAmBA;EACI;IACI,yBAAA;EANN;AACF;AASA;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,qCAAA;EACA,kBAAA;EACA,gBAAA;AAPJ;AAQI;EACI,YAAA;AANR","sourcesContent":["// ==========================================================================\r\n// Component: Public-layout.component\r\n// ==========================================================================\r\n@use \"../../theme/styles/variables\" as *;\r\n\r\n\r\n.top-toolbar{\r\n    position: relative;\r\n    height: $top-toolbar-height;\r\n    z-index: 1;\r\n}\r\n\r\n.pin{\r\n    width: 24px;\r\n    height: 24px;\r\n    cursor: pointer;\r\n    fill: currentColor;\r\n}\r\n\r\n.sidenav{\r\n    width: $sidenav-width;\r\n    overflow: hidden;\r\n    border: none !important;\r\n}\r\n\r\n.header{\r\n    position: relative;\r\n    z-index: 2;\r\n    transition: 0.3s;\r\n    &.over{\r\n        z-index: 99;\r\n    }\r\n}\r\n\r\n.search-bar{\r\n    form{\r\n        input{\r\n            height: 28px;\r\n            border: none;\r\n            padding: 0;\r\n            border-radius: 15px;\r\n            outline: none;\r\n            color: #444;\r\n            width: 0;\r\n            overflow: hidden;\r\n            transition: 0.3s;\r\n            &.show{\r\n               padding: 0 8px;\r\n               width: 250px;\r\n            }\r\n        }       \r\n    }\r\n}\r\n\r\n.footer{    \r\n    height: $footer-toolbar-height;\r\n    position: relative;\r\n    z-index: 3;\r\n}\r\n\r\n\r\n.options{\r\n    position: fixed;\r\n    width: $sidenav-width;\r\n    z-index: 999999;\r\n    .op-header{\r\n        height: $top-toolbar-height;\r\n        padding: 0 14px;\r\n    }\r\n    .control{\r\n        padding: 6px 14px;\r\n        div{\r\n            padding: 6px 0;\r\n        }\r\n        h4{\r\n            border-bottom: 1px solid #ccc;\r\n            margin: 12px 0 6px 0;\r\n        }\r\n        .skin-primary{\r\n            width: 46px;\r\n            height: 46px;\r\n            padding: 0;\r\n            overflow: hidden;            \r\n            cursor: pointer;  \r\n            .skin-secondary{\r\n                width: 0; \r\n                height: 0; \r\n                padding: 0;\r\n                border-bottom: 46px solid; \r\n                border-left: 46px solid transparent;\r\n            }\r\n            &.indigo-light{\r\n                background-color: var(--color-primary-light);\r\n                border: 1px solid var(--color-primary-light);\r\n                .skin-secondary{\r\n                    border-bottom-color: #ececec;\r\n                }\r\n            }\r\n            &.teal-light{\r\n                background-color: #009688;\r\n                border: 1px solid #009688;\r\n                .skin-secondary{\r\n                    border-bottom-color: #ececec;\r\n                }\r\n            }\r\n            &.red-light{\r\n                background-color: #F44336;\r\n                border: 1px solid #F44336;\r\n                .skin-secondary{\r\n                    border-bottom-color: #ececec;\r\n                }\r\n            }\r\n            &.gray-light{\r\n                background-color: #757575;\r\n                border: 1px solid #757575;\r\n                .skin-secondary{\r\n                    border-bottom-color: #ececec;\r\n                }\r\n            }\r\n            &.blue-dark{\r\n                background-color: #0277bd;\r\n                border: 1px solid #0277bd;\r\n                .skin-secondary{\r\n                    border-bottom-color: #262626;\r\n                }\r\n            }\r\n            &.green-dark{\r\n                background-color: #388E3C;\r\n                border: 1px solid #388E3C;\r\n                .skin-secondary{\r\n                    border-bottom-color: #262626;\r\n                }\r\n            }\r\n            &.pink-dark{\r\n                background-color: #D81B60;\r\n                border: 1px solid #D81B60;\r\n                .skin-secondary{\r\n                    border-bottom-color: #262626;\r\n                }\r\n            }\r\n            &.gray-dark{\r\n                background-color: #607D8B;\r\n                border: 1px solid #607D8B;\r\n                .skin-secondary{\r\n                    border-bottom-color: #262626;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .mat-radio-group,\r\n    .mat-mdc-radio-group{\r\n        display: inline-flex;\r\n        flex-direction: column;\r\n        .mat-radio-button,\r\n        .mat-mdc-radio-button{\r\n            margin: 2px 0;\r\n        }\r\n    }\r\n    .mat-slide-toggle,\r\n    .mat-mdc-slide-toggle{\r\n        height: auto;\r\n    }\r\n    .ps{\r\n        height: calc(100% - #{$top-toolbar-height});\r\n    }\r\n}\r\n.op-image{\r\n    box-shadow: 0 0 2px #ccc;\r\n    border: 2px solid;\r\n    border-color: transparent;\r\n    cursor: pointer;\r\n    transition: 0.2s;\r\n}\r\n.options-icon{\r\n    position: fixed;\r\n    top: 120px;\r\n    right: 0;\r\n    width: 40px;\r\n    height: 40px;\r\n    background: rgba(0,0,0,.7);\r\n    color: #fff;\r\n    cursor: pointer;\r\n    z-index: 99999;\r\n    .mat-icon{\r\n        -webkit-animation: spin 8s linear infinite;\r\n        -moz-animation: spin 8s linear infinite;\r\n        animation: spin 8s linear infinite;\r\n    }\r\n}\r\n\r\n@-moz-keyframes spin { \r\n    100% { \r\n        -moz-transform: rotate(360deg); \r\n    } \r\n}\r\n@-webkit-keyframes spin { \r\n    100% { \r\n        -webkit-transform: rotate(360deg); \r\n    } \r\n}\r\n@keyframes spin { \r\n    100% { \r\n        transform: rotate(360deg);\r\n    }\r\n}\r\n\r\n.back-to-top{\r\n    position: fixed;\r\n    width: 40px;\r\n    height: 40px;\r\n    cursor: pointer;\r\n    z-index: 999999;\r\n    right: 20px;\r\n    bottom: 65px;\r\n    opacity: .5;\r\n    color: #fff;\r\n    background-color: rgba(0,0,0,.75);\r\n    border-radius: 50%;\r\n    transition: 0.3s;    \r\n    &:hover{\r\n        opacity: 0.9;\r\n    }    \r\n}","// ==========================================================================\r\n// Component: Variables\r\n// ==========================================================================\r\n$main-font-family: 'Roboto', sans-serif;\r\n\r\n$top-toolbar-height: 56px; \r\n$horizontal-menu-height: 64px; \r\n$footer-toolbar-height: 0px; \r\n//$footer-toolbar-height: 56px; \r\n\r\n$sidenav-width: 260px;\r\n$compact-sidenav-width: 170px;\r\n$mini-sidenav-width: 66px;"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
